import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "disabled"]
const _hoisted_3 = ["value"]

import { computed } from 'vue'
import { PrivacyLevel } from '@/gp/GroupAdminModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyLevelSelect',
  props: {
  id: String,
  modelValue: String,
  disabled: Boolean,
},
  emits: [
  'update:modelValue'
],
  setup(__props, { emit }) {

const props = __props;




const modelValue = computed({
  get() { return props.modelValue },
  set(value) { emit('update:modelValue', value) }
})

const sortedLevels = [
  PrivacyLevel.Me, 
  PrivacyLevel.Friends, 
  PrivacyLevel.Groups, 
  PrivacyLevel.Everyone
]

const displayText = {
  [PrivacyLevel.Me]: 'Only me',
  [PrivacyLevel.Friends]: 'Friends',
  [PrivacyLevel.Groups]: 'Groups',
  [PrivacyLevel.Everyone]: 'Everyone',
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      for: __props.id,
      class: "form-label"
    }, "Visible to", 8, _hoisted_1),
    _withDirectives(_createElementVNode("select", {
      class: "form-select",
      id: __props.id,
      disabled: __props.disabled,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortedLevels, (level) => {
        return _createElementVNode("option", {
          value: level,
          key: level
        }, _toDisplayString(displayText[level]), 9, _hoisted_3)
      }), 64))
    ], 8, _hoisted_2), [
      [_vModelSelect, modelValue.value]
    ])
  ]))
}
}

})